<template>
  <div id="app">
   <!-- 路由 -->
   <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
